import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HomePageLogo from '../assets/basil-thai-logo-clear V02.png';
import BasilThaiLogo from '../assets/basil-thai-logo-clear V02.png'
import RubyThaiLogo from '../assets/ruby-thai-logo.png'
import SakeJapanLogo from '../assets/sake-japan-logo-clear.png'
import NoriJapanLogo from '../assets/nori-japan-logo-clear V02.png'
import NoriSushiLogo from '../assets/nori-sushi-logo V02.png'
import TheWok360Logo from '../assets/the-wok-360-logo.png';
import SakeSushiNRamenLogo from '../assets/sake-japan-logo-clear.png';
import ChinaWokLogo from '../assets/sake-japan-logo-clear.png'
import StirFry88Logo from '../assets/sake-japan-logo-clear.png'


const NavbarContext = createContext();

export const useNavbar = () => useContext(NavbarContext);

export const NavbarProvider = ({ children }) => {
    const [navbarLinks, setNavbarLinks] = useState({
        restaurants: { label: 'Restaurants', path: '/restaurant' },
        about: { label: 'About Us', path: '/about' },
        contact: { label: 'Contact Us', path: '/contact'},
    });

    const [logo, setLogo] = useState(HomePageLogo); // Default logo path
    const [title, setTitle] = useState('ZW Dining Group'); // Default title
    const [titlePath, setTitlePath] = useState('/'); // Default path for title
    const [navbarStyle, setNavbarStyle] = useState({
        color: 'white',
        backgroundColor: 'black',
        position: 'fixed',
    });

    const location = useLocation();

    useEffect(() => {
        const fixedPositionPages = ['/menu', '/about', '/map', '/contact'];

        const isFixedPositionPage = fixedPositionPages.some(page => location.pathname.includes(page));
        // console.log(isFixedPositionPage);

        const restaurantLinks = [
            { label: 'Basil Thai', path: '/restaurants/basilthai' },
            { label: 'Ruby Thai', path: '/restaurants/rubythai' },
            { label: 'Sake Japan', path: '/restaurants/sakejapan' },
            { label: 'Nori Japan', path: '/restaurants/norijapan' },
            { label: 'Nori Sushi', path: '/restaurants/norisushi' },
            { label: 'The Wok 360', path: '/restaurants/thewok360' },
            { label: 'Sake Sushi N Ramen', path: '/restaurants/sakesushinramen' },
            { label: 'China Wok', path: '/restaurants/chinawok' },
            { label: 'Stir Fry 88', path: '/restaurants/stirfry88' },
        ];
    

        // Update the navbar links and title path based on the current location
        if (location.pathname.includes('/restaurants/basilthai')) {
            setNavbarLinks({
                restaurants: restaurantLinks,
                menu: { label: 'Menu', path: '/restaurants/basilthai/menu' },
                map: { label: 'Map', path: '/restaurants/basilthai/map' },
                about: { label: 'About Basil Thai', path: '/restaurants/basilthai/about' },
                contact: { label: 'Contact Us', path: '/restaurants/basilthai/contact'},
            });
            setLogo(BasilThaiLogo); // Set specific logo for Basil Thai
            setTitle('Basil Thai'); // Set title for Basil Thai
            setTitlePath(`/restaurants/basilthai`); // Set specific title path
            setNavbarStyle({
                color: 'white',
                backgroundColor: isFixedPositionPage ? 'rgb(46,204,113, 0.8)' : '',
                backgroundColorSecondary: 'rgb(46,204,113, 1)',
                bodyBackgroundColor: isFixedPositionPage ? 'white' : 'black', // Default background color
                position: isFixedPositionPage ? 'unset' : 'fixed',
            });
        } else if (location.pathname.includes('/restaurants/rubythai')) {
            setNavbarLinks({
                restaurants: restaurantLinks,
                menu: { label: 'Menu', path: '/restaurants/rubythai/menu' },
                map: { label: 'Map', path: 'https://order.online/business/ruby-thai-kitchen-12871999', isExternal: true },
                about: { label: 'About Ruby Thai', path: '/restaurants/rubythai/about' },
                contact: { label: 'Contact Us', path: '/restaurants/rubythai/contact'},
            });
            setLogo(RubyThaiLogo); // Set specific logo for Ruby Thai
            setTitle('Ruby Thai'); // Set title for Ruby Thai
            setTitlePath(`/restaurants/rubythai`); // Set specific title path
            setNavbarStyle({
                color: 'white',
                backgroundColor: isFixedPositionPage ? '#dd0000' : '',
                backgroundColorSecondary: '#dd0000',
                bodyBackgroundColor: isFixedPositionPage ? 'white' : 'black', // Default background color
                position: isFixedPositionPage ? 'unset' : 'fixed',
            });
        } else if (location.pathname.includes('/restaurants/sakejapan')) {
            setNavbarLinks({
                restaurants: restaurantLinks,
                menu: { label: 'Menu', path: '/restaurants/sakejapan/menu' },
                map: { label: 'Map', path: 'https://order.online/business/sake-japan-304460', isExternal: true },
                about: { label: 'About Sake Japan', path: '/restaurants/sakejapan/about' },
                contact: { label: 'Contact Us', path: '/restaurants/sakejapan/contact'},
            });
            setLogo(SakeJapanLogo); // Set specific logo for Sake Japan
            setTitle('Sake Japan'); // Set title for Sake Japan
            setTitlePath(`/restaurants/sakejapan`); // Set specific title path
            setNavbarStyle({
                color: 'white',
                backgroundColor: isFixedPositionPage ? '#dd0000' : '',
                backgroundColorSecondary: '#dd0000',
                bodyBackgroundColor: isFixedPositionPage ? 'white' : 'black', // Default background color
                position: isFixedPositionPage ? 'unset' : 'fixed',
            });
        } else if (location.pathname.includes('/restaurants/norijapan')) {
            setNavbarLinks({
                restaurants: restaurantLinks,
                menu: { label: 'Menu', path: '/restaurants/norijapan/menu' },
                map: { label: 'Map', path: '/restaurants/norijapan/map' },
                about: { label: 'About Nori Japan', path: '/restaurants/norijapan/about' },
                contact: { label: 'Contact Us', path: '/restaurants/norijapan/contact'},
            });
            setLogo(NoriJapanLogo); // Set specific logo for Nori Japan
            setTitle('Nori Japan'); // Set title for Nori Japan
            setTitlePath(`/restaurants/norijapan`); // Set specific title path
            setNavbarStyle({
                color: 'white',
                backgroundColor: isFixedPositionPage ? '#dd0000' : '',
                backgroundColorSecondary: '#dd0000',
                bodyBackgroundColor: isFixedPositionPage ? 'white' : 'black', // Default background color
                position: isFixedPositionPage ? 'unset' : 'fixed',
            });
        } else if (location.pathname.includes('/restaurants/norisushi')) {
            setNavbarLinks({
                restaurants: restaurantLinks,
                menu: { label: 'Menu', path: '/restaurants/norisushi/menu' },
                map: { label: 'Map', path: '/restaurants/norisushi/map' },
                about: { label: 'About Nori Sushi', path: '/restaurants/norisushi/about' },
                contact: { label: 'Contact Us', path: '/restaurants/norisushi/contact'},
            });
            setLogo(NoriSushiLogo); 
            setTitle('Nori Sushi');
            setTitlePath(`/restaurants/norisushi`); // Set specific title path
            setNavbarStyle({
                color: 'white',
                backgroundColor: isFixedPositionPage ? '#dd0000' : '',
                backgroundColorSecondary: '#dd0000',
                bodyBackgroundColor: isFixedPositionPage ? 'white' : 'black', // Default background color
                position: isFixedPositionPage ? 'unset' : 'fixed',
            });
        } else if (location.pathname.includes('/restaurants/thewok360')) {
            setNavbarLinks({
                restaurants: restaurantLinks,
                menu: { label: 'Menu', path: '/restaurants/thewok360/menu' },
                map: { label: 'Map', path: '/restaurants/thewok360/map' },
                about: { label: 'About The Wok 360', path: '/restaurants/thewok360/about' },
                contact: { label: 'Contact Us', path: '/restaurants/thewok360/contact'},
            });
            setLogo(TheWok360Logo); // Set specific logo for The Wok 360
            setTitle('The Wok 360'); // Set title for The Wok 360
            setTitlePath(`/restaurants/thewok360`); // Set specific title path
            setNavbarStyle({
                color: 'white',
                backgroundColor: isFixedPositionPage ? '#dd0000' : '',
                backgroundColorSecondary: '#dd0000',
                bodyBackgroundColor: isFixedPositionPage ? 'white' : 'black', // Default background color
                position: isFixedPositionPage ? 'unset' : 'fixed',
            });
            } else if (location.pathname.includes('/restaurants/thewok360')) {
            setNavbarLinks({
                restaurants: restaurantLinks,
                menu: { label: 'Menu', path: '/restaurants/thewok360/menu' },
                map: { label: 'Map', path: '/restaurants/thewok360/map' },
                about: { label: 'About The Wok 360', path: '/restaurants/thewok360/about' },
                contact: { label: 'Contact Us', path: '/restaurants/thewok360/contact'},
            });
            setLogo(TheWok360Logo); // Set specific logo for The Wok 360
            setTitle('The Wok 360'); // Set title for The Wok 360
            setTitlePath(`/restaurants/thewok360`); // Set specific title path
            setNavbarStyle({
                color: 'white',
                backgroundColor: isFixedPositionPage ? '#dd0000' : '',
                backgroundColorSecondary: '#dd0000',
                bodyBackgroundColor: isFixedPositionPage ? 'white' : 'black', // Default background color
                position: isFixedPositionPage ? 'unset' : 'fixed',
            });
        } else if (location.pathname.includes('/restaurants/sakesushinramen')) {
            setNavbarLinks({
                restaurants: restaurantLinks,
                menu: { label: 'Menu', path: '/restaurants/sakesushinramen/menu' },
                map: { label: 'Map', path: 'https://order.online/business/sake-sushi-n-ramen-12788062', isExternal: true },
                about: { label: 'About Sake Sushi Ramen', path: '/restaurants/sakesushinramen/about' },
                contact: { label: 'Contact Us', path: '/restaurants/sakesushinramen/contact'},
            });
            setLogo(SakeSushiNRamenLogo); // Set specific logo for Sake Sushi N Ramen
            setTitle('Sake Sushi N Ramen'); // Set title for Sake Sushi N Ramen
            setTitlePath(`/restaurants/sakesushinramen`); // Set specific title path
            setNavbarStyle({
                color: 'white',
                backgroundColor: isFixedPositionPage ? '#dd0000' : '',
                backgroundColorSecondary: '#dd0000',
                bodyBackgroundColor: isFixedPositionPage ? 'white' : 'black', // Default background color
                position: isFixedPositionPage ? 'unset' : 'fixed',
            });
        } else if (location.pathname.includes('/restaurants/chinawok')) {
            setNavbarLinks({
                restaurants: restaurantLinks,
                menu: { label: 'Menu', path: '/restaurants/chinawok/menu' },
                map: { label: 'Map', path: 'https://order.online/business/china-wok-brass-mill-mall-chinese-restaurant-11250058', isExternal: true },
                about: { label: 'About China Wok', path: '/restaurants/chinawok/about' },
                contact: { label: 'Contact Us', path: '/restaurants/chinawok/contact'},
            });
            setLogo(ChinaWokLogo); // Set specific logo for China Wok
            setTitle('China Wok'); // Set title for China Wok
            setTitlePath(`/restaurants/chinawok`); // Set specific title path
            setNavbarStyle({
                color: 'white',
                backgroundColor: isFixedPositionPage ? '#dd0000' : '',
                backgroundColorSecondary: '#dd0000',
                bodyBackgroundColor: isFixedPositionPage ? 'white' : 'black', // Default background color
                position: isFixedPositionPage ? 'unset' : 'fixed',
            });
        } else if (location.pathname.includes('/restaurants/stirfry88')) {
            setNavbarLinks({
                restaurants: restaurantLinks,
                menu: { label: 'Menu', path: '/restaurants/stirfry88/menu' },
                map: { label: 'Map', path: 'https://order.online/business/stir-fry-88-11518986', isExternal: true },
                about: { label: 'About Stirfry 88', path: '/restaurants/stirfry88/about' },
                contact: { label: 'Contact Us', path: '/restaurants/stirfry88/contact'},
            });
            setLogo(StirFry88Logo); // Set specific logo for Stirfry 88
            setTitle('Stir Fry 88'); // Set title for Stirfry 88
            setTitlePath(`/restaurants/stirfry88`); // Set specific title path
            setNavbarStyle({
                color: 'white',
                backgroundColor: isFixedPositionPage ? '#dd0000' : '',
                backgroundColorSecondary: '#dd0000',
                bodyBackgroundColor: isFixedPositionPage ? 'white' : 'black', // Default background color
                position: isFixedPositionPage ? 'unset' : 'fixed',
            });
            
        } else {
            // Revert to default links and logo
            setNavbarLinks({
                restaurants: restaurantLinks,
                about: { label: 'About Us', path: '/about' },
                contact: { label: 'Contact Us', path: '/contact'},
            });
            setLogo(HomePageLogo); // Default logo
            setTitle('ZW Dining Group'); // Default title
            setTitlePath('/'); // Default title path
            setNavbarStyle({
                // color: 'white',
                backgroundColor: '',
                backgroundColorSecondary: '#1A1A1A',
                bodyBackgroundColor: 'black', // Default background color
                position: isFixedPositionPage ? 'relative' : 'fixed',
            });
        }
    }, [location.pathname]);

    return (
        <NavbarContext.Provider value={{ navbarLinks, logo, title, titlePath, navbarStyle }}>
            {children}
        </NavbarContext.Provider>
    );
};
